<template>
  <v-row class=" mx-0">
    <v-col cols="12" sm="2" md="2" lg="2">
    </v-col>
    <v-col cols="12" sm="8" md="8" lg="8">
      <v-card class="py-10">
        <div>
        </div>
        <div>
            <v-row justify="center" class="mb-12 mx-0">
                <v-col cols="12" sm="10" md="8" class="pa-0">
                    <h2 class="ml-2 mb-4" align="center"><v-icon color="success">fa-check-circle</v-icon> เช็คสถานะ</h2>
                    <div class="separator"></div>
                </v-col>
            </v-row>

            <v-row justify="center" class="mb-12 mx-0">
                <v-col cols="12" sm="10" md="8" class="pa-0">
                    <v-row class="mx-0">
                      <v-col cols="12" md="12" lg="12">
                        กรุณากรอกเลขที่ใบสั่งซื้อ หรือ เบอร์โทรผู้รับ
                      </v-col>
                      <v-col cols="12" md="8" lg="9">
                        <v-text-field
                           ref="sh_order_id_or_phone"
                           v-model="sh_order_id_or_phone"
                           autocomplete="off"
                           outlined
                           hide-details
                           dense
                           required
                           @keyup.enter="search_order_by_id_and_phone()"

                       ></v-text-field>
                     </v-col>
                     <v-col cols="12" md="4" lg="3">
                       <v-btn color="primary" width="100%" @click="search_order_by_id_and_phone()" :loading="loading">
                           <div><v-icon left>fa-search</v-icon> ค้นหา</div>
                       </v-btn>
                     </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row justify="center" class="mb-12 mx-0" v-if="bt_click == true && data_res.length == 0 ">
                <v-col cols="12" sm="10" md="8" class="pa-0">
                    <div class="separator"></div>
                    <v-row class=" mx-0">
                        <v-col cols="12" sm="12" lg="4" >
                          <span style="color: red;" >ไม่พบข้อมูล !!</span>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
      </v-card>


      <v-card class="my-5 pa-5" v-for="(item, index) in data_res" :key="index">
        <v-row >
          <v-col cols="6" sm="6" md="4" lg="4" xl="6" class="py-2">
            <b>
              <span style="color: #1976d2 !important; ">{{ format_order_id(item.id) }}</span>
           </b>
          </v-col>
          <v-col cols="6" sm="6" md="8" lg="8" xl="6" align="right" class="py-2">
            {{ format_datetime(item.createdDatetime) }}
          </v-col>
          <v-col cols="4" sm="4" md="4" lg="4" xl="6" class="py-2"><b> ที่อยู่ผู้รับ : </b></v-col>
          <v-col cols="8" sm="8" md="8" lg="8" xl="6" align="right" class="py-2">
            <span>{{ item.receiverName + ' ' + item.receiverPhone + ' ' + item.receiverSubDistrict + ' ' + item.receiverDistrict + ' ' + item.receiverProvince + ' ' + item.receiverPostcode }}</span>
          </v-col>
          <v-col cols="6" sm="6" md="4" lg="4" xl="6" class="py-2"><b> สถานะ : </b></v-col>
          <v-col cols="6" sm="6" md="8" lg="8" xl="6" align="right" class="py-2">
            {{ item.shippingStatusName }}
          </v-col>
          <v-col cols="6" sm="6" md="4" lg="4" xl="6" class="py-2"><b> ขนส่ง : </b></v-col>
          <v-col cols="6" sm="6" md="8" lg="8" xl="6" align="right" class="py-2">
            <span v-if="item.expressCompanyId != null">
              <span>
                <v-img
                    :src="item.expressCompanyLogo"
                    class="grey lighten-2"
                    max-width="70"
                    max-height="70"
                ></v-img>
              </span>
            </span>
            <span v-else></span>
          </v-col>
          <v-col cols="6" sm="6" md="4" lg="4" xl="6" class="py-2"><b> TrackingNo : </b></v-col>
          <v-col cols="6" sm="6" md="8" lg="8" xl="6" align="right" class="py-2">
            <span v-if="item.trackingNo != null">{{item.trackingNo}}</span>
            <span v-else>-</span>
          </v-col>
          <v-col cols="6" sm="6" md="4" lg="4" xl="6" class="py-2"><b> เลขอ้างอิง : </b></v-col>
          <v-col cols="6" sm="6" md="8" lg="8" xl="6" align="right" class="py-2">
            <span v-if="item.referenceNumber != null">{{item.referenceNumber}}</span>
            <span v-else>-</span>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-2">
            <a @Click="Openweb(item.token)" target="_blank" style="text-decoration: none;">
              <v-btn color="info" outlined width="100%">รายละเอียด</v-btn>
            </a>
           </v-col>
        </v-row>
        </v-card>

    </v-col>
  </v-row>
</template>

<script>
    import axios from 'axios'
    import { format_order_id } from '@/website/global_function'
    import { orderService_dotnet } from '@/website/global'
    import { header_token } from '@/website/token'

    export default {
        data: () => ({

            loading: false,
            sh_order_id_or_phone: null,
            data_res: [],
            detail_token: null,
            sh_phone: null,
            bt_click: false,
        }),

        created () {

        },

        methods: {
            format_order_id,
            async search_order_by_id_and_phone () {

              if(this.sh_order_id_or_phone == null || this.sh_order_id_or_phone == ''){
                this.$refs.sh_order_id_or_phone.focus()
                return
              }

              this.loading = true
              let response = await axios.post(orderService_dotnet+'Order/search-order-by-keyword', {
                "keyword": this.sh_order_id_or_phone,
              },
              { headers: header_token})
              this.loading = false
              var res = response.data
              if(res.resultCount > 0) {
                if(res.resultCount == 1){
                  this.$router.push({ path: `purchase-order=${res.orderList[0].token}`})
                }
                this.data_res = res.orderList
                this.bt_click = false
              } else {
                this.data_res = res.orderList
                this.bt_click = true
              }

             },

             format_datetime (val) {
               if(val != null){
                 var date_tmp = val.substring(0, 10)
                 const date_split = date_tmp.split('-');
                 var time_tmp = val.substring(11, 19)
                 var set_dattime = date_split[2]+'-'+date_split[1]+'-'+date_split[0] +' '+ time_tmp
                 return set_dattime
               } else {
                 return ""
               }
             },

             Openweb (token) {
               window.open("/purchase-order="+token);
             },
        }
    }
</script>

/* <style scoped>
  .packhai-border-table {
    border:1px solid rgba(0, 0, 0, 0.12);
    border-radius:4px;
  }
  .packhai-border-table thead {
    color:white;
  }
  .packhai-border-table thead tr th {
    font-weight: bold;
    font-size: 1rem;
  }
</style> */
